import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarCheck } from "lucide-react";
import WhatsAppIcon from "./WhatsAppIcon";
import { waLink } from "../lib/whatsapp";
import { openBooking } from "../lib/booking";

/* Desktop-only sticky booking bar — slides in once the visitor scrolls past the hero */
const StickyCTA = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("sticky-cta-on", show);
    return () => document.documentElement.classList.remove("sticky-cta-on");
  }, [show]);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/admin") || pathname.startsWith("/payment")) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="hidden md:flex fixed bottom-6 right-6 z-[70] items-center gap-4 rounded-full border border-[#E5C56F]/25 pl-5 pr-2 py-2"
          style={{ background: "rgba(6,10,26,0.86)", backdropFilter: "blur(16px)", boxShadow: "0 24px 60px -20px rgba(0,0,0,0.8), 0 0 0 1px rgba(168,85,247,0.08) inset" }}
          data-testid="sticky-cta-bar"
        >
          <div className="text-[11px] tracking-[0.2em] uppercase text-zinc-300 whitespace-nowrap">
            Strategy Call · <span className="gold-text">$250</span> · 30 min · credited to your engagement
          </div>
          <a
            href={waLink("Hi Ah-Jin Group — I'd like to book the $250 strategy call.")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-[#4be284] hover:text-[#7ef0a6] transition-colors"
            data-testid="sticky-cta-whatsapp"
          >
            <WhatsAppIcon size={13} /> Ask a question
          </a>
          <button
            type="button"
            onClick={() => openBooking("sticky-bar")}
            className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#E5C56F] to-[#C9A64B] px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#1a1405] hover:brightness-110 transition-all"
            data-testid="sticky-cta-book"
          >
            <CalendarCheck size={14} /> Book the call
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
